// extracted by mini-css-extract-plugin
export default {"mainDescription":"SuperVisiory_mainDescription__eXD8d","workersWrapper":"SuperVisiory_workersWrapper__40in8"};